var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBox({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "only-fill",
    d: "M6.29995 12.9424V8.14737L2.09995 5.71487V10.5099L6.29995 12.9424ZM7.69995 12.9424L11.9 10.5099V5.71487L7.69995 8.14737V12.9424ZM6.99995 6.93987L11.1475 4.54237L6.99995 2.14487L2.85245 4.54237L6.99995 6.93987ZM1.39995 11.7349C1.17828 11.6065 1.0062 11.4374 0.883701 11.2274C0.761201 11.0174 0.699951 10.784 0.699951 10.5274V4.96237C0.699951 4.70571 0.761201 4.47237 0.883701 4.26237C1.0062 4.05237 1.17828 3.88321 1.39995 3.75487L6.29995 0.937373C6.52162 0.80904 6.75495 0.744873 6.99995 0.744873C7.24495 0.744873 7.47828 0.80904 7.69995 0.937373L12.6 3.75487C12.8216 3.88321 12.9937 4.05237 13.1162 4.26237C13.2387 4.47237 13.3 4.70571 13.3 4.96237V10.5274C13.3 10.784 13.2387 11.0174 13.1162 11.2274C12.9937 11.4374 12.8216 11.6065 12.6 11.7349L7.69995 14.5524C7.47828 14.6807 7.24495 14.7449 6.99995 14.7449C6.75495 14.7449 6.52162 14.6807 6.29995 14.5524L1.39995 11.7349Z",
    fill: "#141B34"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBox);
export default __webpack_public_path__ + "static/media/box.9fd6634bf903f1f7bea09830e5a01354.svg";
export { ForwardRef as ReactComponent };